<template>
    <div class="info-agent" v-if="agent && (agent.firstName || agent.lastName)">
        <AgentHeadShot class="agent-image" :headshots="agent.headShots" :initImage="agent.image" :keyClass="`md-form-info-agent-v2-`+dataid" />
        <div v-if="agent.firstName || agent.lastName" class="agent-detail">
            <site-title :title="`${ agent.firstName || '' } ${ agent.lastName || '' }`" align="center" />
            <template v-if="styleType === 'v2'">
                <p v-if="agent.phone" class="phone">
                    <a
                        :href="'tel:' + agent.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >
                        <i class="iconfont icon-phone-round"></i>
                        <span>{{ $ft.formatPhone(agent.phone) }}</span>
                    </a>
                </p>
                <p class="position mobile">
                    {{ agent.position || ''
                    }}<span v-if="agent.position && agent.license" style="opacity:0.3;"> | </span>
                    <span
                        v-if="agent.license"
                    >{{ licenseName }} {{ agent.license }}</span>
                </p>
                <p class="position">
                    <span v-if="agent.position">{{ agent.position }}</span>
                    <span
                        v-if="agent.license"
                    >{{ licenseName }} {{ agent.license }}</span>
                </p>
            </template>
            <template v-if="styleType === 'v3'">
                <p class="position">
                    {{ agent.position || ''
                    }}<span v-if="agent.position && agent.license" style="opacity:0.3;"> | </span>
                    <span
                        v-if="agent.license"
                    >{{ licenseName }} {{ agent.license }}</span>
                </p>
                <p v-if="agent.phone" class="phone">
                    <a
                        :href="'tel:' + agent.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >{{ $ft.formatPhone(agent.phone) }}</a>
                    <span v-if="agent.phone && agent.email" style="opacity:0.3;"> | </span>
                    {{ agent.email }}
                </p>
            </template>
            <template v-else>
                <p class="position">
                    {{ agent.position || ''
                    }}<span v-if="agent.position && agent.license" style="opacity:0.3;"> | </span>
                    <span
                        v-if="agent.license"
                    >{{ licenseName }} {{ agent.license }}</span>
                </p>
                <p v-if="agent.phone" class="phone">
                    <a
                        :href="'tel:' + agent.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >{{ $ft.formatPhone(agent.phone) }}</a>
                </p>
            </template>
        </div>
    </div>
</template>

<script>
import util from '@/common/util';
import AgentHeadShot from "@/components/agent-headshot.vue"
export default {
    props: {
        agent: {
            type: Object,
            required: true
        },
        licenseName: {
            type: String,
            required: true
        },
        styleType: {
            type: String,
            default: 'v1'
        }
    },
    components: {
        AgentHeadShot
    },
    data: function() {
        return {
            dataid: util.uuidv4(),
        }
    }
};
</script>

